export var ConversationStatus;

(function (ConversationStatus) {
  ConversationStatus["Active"] = "active";
  ConversationStatus["Archived"] = "archived";
  ConversationStatus["Deleted"] = "deleted";
})(ConversationStatus || (ConversationStatus = {}));